import { render, staticRenderFns } from "./ChoicesWidget.vue?vue&type=template&id=c99cb736&scoped=true&"
import script from "./ChoicesWidget.vue?vue&type=script&lang=js&"
export * from "./ChoicesWidget.vue?vue&type=script&lang=js&"
import style0 from "./ChoicesWidget.vue?vue&type=style&index=0&id=c99cb736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c99cb736",
  null
  
)

export default component.exports